import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import SEO from '@common/SEO';
import Main from '@common/Main';
import Section from '@common/Section';
import Container from '@common/Container';
import Heading from '@common/Heading';
import Row from '@common/Row';
import Link from '@common/Link';
import Button from '@common/Button';
import Logo from '@images/blog/blog_logo.svg';
import ECEMonthlyLogo from '@images/blog/ece_monthly.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import FeaturedArticle from '@components/blog/post/FeaturedArticle';
import ArticleCard from '@components/blog/post/ArticleCard';

export const query = graphql`
  query { 
    recent: allWpPost(limit: 8, sort: {date: DESC}) {
      nodes {
        author {
          node {
            name
            slug
          }
        }
        date
        featuredImage {
          node {
            sourceUrl
          }
        }
        link
        title
        categories {
          nodes {
            name
            link
          }
        }
      }
    }
  }
`
const Home = ({ data }) => {
  const { nodes } = data?.recent;
  const firstPost = nodes[0];
  const recentPost = nodes.slice(1, nodes.length);
  return (
    <Main>
      <Section spacing='mt-5'>
        <Container>
          <Heading type='h1' className='d-none'>{'Building Blocks - The Lillio Early Learning Blog'}</Heading>
          <FeaturedArticle data={firstPost}/>
          <Heading type='h2' className='h3 text-uppercase'>{'Browse Articles'}</Heading>
          {recentPost &&
            <Row className='row-cols-md-2 row-cols-lg-3 g-3'>
              {recentPost.map((post, index) => {
                if (index == 3) {
                  return (
                    <Fragment key={index}>
                      <div className='d-flex p-1'>
                        <div className='p-4 rounded bg-light-green'>
                          <div className='mb-4 text-center'>
                            <StaticImage src={`../../images/blog/lillio_webinars.svg`} placeholder='none' alt='' />
                          </div>
                          <p className='fs-24 fw-medium mb-4 text-dark-grey-4'>{'Join us live for early childhood chats with industry experts!'}</p>
                          <Button
                            variant='outline-black'
                            addClass='ff-inter fw-semibold'
                            to={'/blog/category/webinar'}
                            copy={'Sign Up'}
                          />
                        </div>
                      </div>
                      <ArticleCard data={post}/>
                    </Fragment>
                  )
                }
                return (
                  <ArticleCard key={index} data={post}/>
                )
              })}
              <div className='d-flex p-1'>
                <div className='p-4 rounded bg-light-red'>
                  <div className='mb-4 text-center'>
                    <StaticImage src={`../../images/blog/preschool_podcast.png`} placeholder='none' alt='' />
                  </div>
                  <p className='fs-24 fw-medium mb-4 text-dark-grey-4'>{'Join us as we discuss early childhood education industry with experts!'}</p>
                  <Button
                    variant='outline-black'
                    addClass='ff-inter fw-semibold'
                    to={'/blog/category/podcast'}
                    copy={'Sign Up'}
                  />
                </div>
              </div>
            </Row>
          }
          <div className='d-flex flex-column align-items-center justify-content-center mt-5 mb-3'>
            <Link to={'/blog/articles'} className='d-flex'>
              <p className='fs-22 mb-0'>{'View All Articles'}</p>
              <FontAwesomeIcon icon={faChevronRight} style={{margin: '5px 5px'}}/>
            </Link>
          </div>
        </Container>
      </Section>
      <Section>
        <Container>
          <Row className='mb-5'>
            <div className='p-4 rounded bg-light-yellow'>
              <img src={ECEMonthlyLogo} alt='' className='mb-4'/>
              <p className='fs-24 fw-medium mb-4 text-dark-grey-4'>{'Monthly articles sent directly to your inbox.'}</p>
              <Button
                variant='outline-black'
                addClass='ff-inter fw-semibold'
                to={'https://wow.himama.com/newsletter-signup/'}
                copy={'Sign Up'}
              />
            </div>
          </Row>
        </Container>
      </Section>
      <Section>
        <Container>
          <Row>
            <div className='col-md-4'>
              <img src={Logo} width={'100%'} alt=''/>
            </div>
            <div className='col'>
              {'Check out the Lillio blog for your all-in-one source for everything you need to know about the building blocks of high-quality childcare! We cover the latest on early childhood education, childcare center management, family engagement, professional development, and more. Find the latest on trends, innovations, inspiration, and best practices in the early childhood education industry.'}
            </div>
          </Row>
        </Container>
      </Section>
    </Main>
  )
}

export default Home

export const Head = ({ location }) => {
  return (
    <SEO
      index={true}
      titleTag={'Blog'} 
      location={location}
      metaDescription={'Check out the Lillio blog for your all-in-one source for everything you need to know about the building blocks of high-quality childcare! We cover the latest on early childhood education, childcare center management, family engagement, professional development, and more.'}
    />
  )
}
